import(/* webpackMode: "eager" */ "/home/runner/work/highrays-yt/highrays-yt/src/app/(public)/auth/login/page.tsx");
